import { server } from "@/api";

const prefix = 'api/sponsors';
const adminPrefix = 'api/admin/sponsors';

export const all = async () => {
    return await server().get(prefix);
};

export const admin = {
    paginate: async (data = {}) => {
        return await server().get(adminPrefix, { params: data });
    },
    store: async (data) => {
        return await server().post(adminPrefix, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    update: async (id, data) => {
        return await server().post(adminPrefix + '/' + id, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    destroy: async (id) => {
        return await server().delete(adminPrefix + '/' + id);
    },
    toggleStatus: async (id) => {
        return await server().put(adminPrefix + '/' + id + '/toggle-status');
    }
};

const sponsorsApi = {
    all,
    admin
};

export default sponsorsApi; 